import * as types from './mutation-types'

export default {
  [types.ADD_ZONES](state, data) {
    state.zones = data.zones
  },
  [types.ADD_ZONE] (state, data) {
    state.zones.push(data)
  },
  [types.ADD_ZONES_INTERVALS](state, data) {
    state.zone_intervals = data
  },
}
